const serviceCreationBlockedModal = {
  title: 'Service creation is blocked',
  text: 'Service creation is only available scanning the equipment QRCODE in the App',
  okButton: 'Ok',
};

export default serviceCreationBlockedModal;
